import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import { AppState } from './stores/appStateStore';
import App from './components/App';
import { initialStyleState } from './stores/styleStore';
import { action, runInAction } from 'mobx';

const appStateStore = runInAction(() => {return new AppState();});
const styleStore = initialStyleState;

declare global {
	interface Window {
		appState: any;
		styleState: any;
	}
}
window.appState = appStateStore;
window.styleState = styleStore;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<App state={appStateStore} styles={styleStore} />
	</React.StrictMode>
);

// For file drag upload
window.addEventListener(
	'dragenter',
	e => {
		e.preventDefault();

		action(() => {
			styleStore.get('dropzone').removeClass('hidden');
		})();
	},
	false
);

window.addEventListener(
	'dragover',
	e => {
		e.preventDefault();
	},
	false
);

window.addEventListener(
	'drop',
	e => {
		e.preventDefault();
	},
	false
);
